<template>
  <b-nav-item @click="refreshUser">
    <feather-icon
      size="21"
      icon="RefreshCcwIcon"
    />
  </b-nav-item>
</template>

<script>
import { BNavItem } from 'bootstrap-vue'
import {
  getLoginType, setRefreshToken, setToken, setUser,
} from '@/auth/utils'
import { LOGIN_TYPE } from '@/const/type'
import ability from '@/libs/acl/ability'
import { ApiCode } from '@/const/api'
import api from './api'

export default {
  name: 'UserRefresh',
  components: { BNavItem },
  methods: {
    async refreshUser() {
      const loginType = getLoginType()
      if (loginType === LOGIN_TYPE.NORMAL) {
        const response = await api.verify()
        if (response.code === ApiCode.SUCCESS) {
          const { data } = response
          const { accessToken, refreshToken, user } = data
          setToken(accessToken)
          setRefreshToken(refreshToken)
          this.updateUser(user)
        }
      } else if (loginType === LOGIN_TYPE.SSO) {
        const response = await api.verifySso()
        if (response.code === ApiCode.SUCCESS) {
          const { data } = response
          this.updateUser(data)
        }
      }
    },
    updateUser(user) {
      setUser(user)
      ability.update(JSON.parse(user).abilities)
      this.$router.go(0)
    },
  },
}
</script>
